import { call, put, takeEvery } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';
import combinedActions from '~redux/combinedActions';

import { store } from '~redux/store';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchCloseDashboardMarket(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardCloseDashboardMarketAttempt', handleCloseDashboardMarket, api);
}

function* handleCloseDashboardMarket(api: DashboardGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.closeDashboardMarket], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardCloseDashboardMarketFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardIsMarketStatusCloseConfimationModalOpen(false));
        yield put(combinedActions.dashboardGetDashboardMarketStatusAttempt());
        yield put(combinedActions.dashboardCloseDashboardMarketSuccess(response.data));
    }
}
